export function getHeaderBag(headers) {
    return headers.reduce((acc, [header, ...values]) => (Object.assign(Object.assign({}, acc), { [header]: values.join(', ') })), {});
}
export function getHeaderList(headerBag) {
    return Object.entries(headerBag);
}
